import React, { createContext, useContext } from 'react';
import { Subscribe } from 'unstated';

import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';
import { SidePanel } from '@confluence/side-panel';

const SidePanelWidthContext = createContext<number | undefined>(undefined);

export const SidePanelWidthProvider: React.Provider<number | undefined> =
	SidePanelWidthContext.Provider;

export const SidePanelWrapper = ({
	children,
	isOpen = true,
}: {
	children: React.ReactNode;
	isOpen?: boolean;
}): React.JSX.Element => {
	const width = useContext(SidePanelWidthContext);

	return (
		<Subscribe to={[BannerStateContainer]}>
			{(bannerState: BannerStateContainer) => {
				const headerHeight = bannerState.getTotalHeight(true);
				return (
					<SidePanel
						isFixed
						headerHeight={headerHeight}
						panelTop={headerHeight}
						isOpen={isOpen}
						width={width}
					>
						{children}
					</SidePanel>
				);
			}}
		</Subscribe>
	);
};
